import { axiosInstance } from "api/axios.instance"
import type { AxiosResponse } from "axios"
import type { TDimensions, TModelNumberPricePayloadItem } from "types/modelNumbers.type"

type ImageResponse = AxiosResponse<{
	download_url: string
}>

class ModelNumbersService {
	static MODEL_NUMBERS = "model-numbers"

	async getModelNumbers() {
		return axiosInstance.get(`${ModelNumbersService.MODEL_NUMBERS}/`)
	}

	async getModelNumber(id: number) {
		return axiosInstance.get(`${ModelNumbersService.MODEL_NUMBERS}/${id}/`)
	}

	async addModelNumber(formData: FormData) {
		return axiosInstance.post(`${ModelNumbersService.MODEL_NUMBERS}/`, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		})
	}

	async editModelNumber(modelNumber: string, id: number) {
		return axiosInstance.patch(`${ModelNumbersService.MODEL_NUMBERS}/${id}/`, { model_number: modelNumber })
	}

	async deleteModelNumber(id: number) {
		return axiosInstance.delete(`${ModelNumbersService.MODEL_NUMBERS}/${id}/`)
	}

	async uploadModelNumberImage(id: number, image: File): Promise<ImageResponse> {
		const formData = new FormData()
		formData.append("model_number_image", image)

		return axiosInstance.put(`${ModelNumbersService.MODEL_NUMBERS}/${id}/catalogue_image/`, formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		})
	}

	async getModelNumberImageLink(id: number): Promise<ImageResponse> {
		return axiosInstance.get(`${ModelNumbersService.MODEL_NUMBERS}/${id}/catalogue_image/`)
	}

	async updateModelNumberCategories(id: number, relatedCategoryId: number | null) {
		return axiosInstance.patch(`${ModelNumbersService.MODEL_NUMBERS}/${id}/category/`, {
			related_category_id: relatedCategoryId,
		})
	}

	async updateModelNumberDimensions(id: number, dimensions: TDimensions) {
		return axiosInstance.patch(`${ModelNumbersService.MODEL_NUMBERS}/${id}/dimensions/`, dimensions)
	}

	async updateModelNumberPrices(id: number, prices: TModelNumberPricePayloadItem[]) {
		return axiosInstance.patch(`${ModelNumbersService.MODEL_NUMBERS}/${id}/prices/`, prices)
	}
}

export default new ModelNumbersService()
